import { useState } from 'react'
import { useCookies } from 'react-cookie'
import { useSelector } from 'react-redux'
require('./index.scss')

import { Dialog as ModalDialog } from '@reach/dialog'

import {
  isRecommendingRegionSelector,
  recommendedRegionSelector,
  recommendedRegionTextSelector
} from '@/selectors'
import { translate } from '@/utils/translations'

import Content from './Content'

const RegionRecommendationNotice = () => {
  const [isShowing, setIsShowing] = useState(true)
  const cookieName = useSelector(
    state => state.regionRecommendation.cookieName
  )
  const cookieValue = useSelector(
    state => state.regionRecommendation.cookieValue
  )

  const { 1: setCookie } = useCookies([cookieName])
  const [cookies] = useCookies()

  const isRecommendingRegion = useSelector(isRecommendingRegionSelector)
  const hasBookshelfCookie = Boolean(cookies.bookshelfSingleSignOnRegionCookie)

  if (!isRecommendingRegion || hasBookshelfCookie) { return null }

  const recommendedRegion = useSelector(recommendedRegionSelector)

  const recommendationText = useSelector(recommendedRegionTextSelector)

  const { storeUrl, displayName } = recommendedRegion

  const writeCookie = () => (
    setCookie(cookieName, cookieValue, {
      maxAge: 31536000, path: '/'
    })
  )

  const onContinue = () => {
    writeCookie()
    window.location.assign(storeUrl)
  }

  const onClose = () => {
    writeCookie()
    setIsShowing(false)
  }

  return (
    <ModalDialog
      data-testid='dialog'
      heading={translate('common.confirm_your_region')}
      id='region-recommendation-modal'
      isOpen={isShowing}
    >
      <Content
        pleaseVisitText={recommendationText}
      >        
        <div className='d-flex justify-content-between'>
          <button
            className='vst-btn--large vst-btn--ocean-outline'
            onClick={onClose}
          >
            {translate('common.cancel')}
          </button>
          <button
            className='vst-btn--large vst-btn--ocean'
            onClick={onContinue}
          >
            {displayName}
          </button>
        </div>
        
      </Content>
    </ModalDialog>
  )
}

export default RegionRecommendationNotice
